<template>
  <LmDialog v-model="modalShow" title="Form preview">
    <template #toolbar-actions>
      <q-btn v-if="!form.id" color="positive" @click="actionClicked('save')">
        Save
      </q-btn>

      <q-btn v-else color="positive" @click="actionClicked('update')">
        Update
      </q-btn>
    </template>

    <template #content>
      <div class="content">
        <CustomFormRenderer :form="form" />
      </div>
    </template>
  </LmDialog>
</template>

<script>
import LmDialog from '@/reusable/base-components/LmDialog/LmDialog'
import CustomFormRenderer from '@components/lm-blocks/CustomFormRenderer'

export default {
  components: {
    LmDialog,
    CustomFormRenderer
  },

  props: {
    value: {
      type: Boolean,
      required: true
    },

    form: {
      type: Object,
      required: true
    }
  },

  computed: {
    modalShow: {
      get() {
        return this.value
      },

      set(newVal) {
        this.$emit('input', newVal)
      }
    }
  },

  methods: {
    actionClicked(action) {
      this.$emit(action)
      this.modalShow = false
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/stylus/mixins'

>>> .q-field.col-4 { // display fields in full width
  width 100%
}

.dialog-card {
  width: 600px;
  max-width: 600px;
}

styledScrollFor('.content');

.content {
  padding 15px
  overflow auto
}
</style>
